/** Shared copyright + legal links for app shell and landing footers. */

import { wireLegalLinks } from "./legal-lightbox.js?v=20261007m";

const COPYRIGHT_START_YEAR = 2024;

export function copyrightNotice() {
  const year = new Date().getFullYear();
  const years = year > COPYRIGHT_START_YEAR ? `${COPYRIGHT_START_YEAR}–${year}` : String(year);
  return `© ${years} Elzbiet Zaleski. CookieCodeJar. All rights reserved.`;
}

export function legalFooterLinksHtml() {
  return `<nav class="site-footer__legal" aria-label="Legal">
    <a href="faq.html">FAQ</a>
    <a href="support.html">Support</a>
    <a href="terms.html">Terms</a>
    <a href="privacy.html">Privacy</a>
    <a href="asset-usage.html">Asset usage</a>
  </nav>`;
}

export function siteFooterInnerHtml() {
  return `${legalFooterLinksHtml()}<p class="site-footer__copy">${copyrightNotice()}</p>`;
}

function ensureAppShellFooter(main) {
  let footer = main.querySelector(".site-footer");
  if (!footer) {
    footer = document.createElement("footer");
    footer.className = "site-footer";
    main.appendChild(footer);
  }
  let legal = footer.querySelector(".site-footer__legal");
  if (!legal) {
    footer.insertAdjacentHTML("afterbegin", legalFooterLinksHtml());
    legal = footer.querySelector(".site-footer__legal");
  }
  if (legal && !legal.querySelector('a[href="support.html"]')) {
    const faq = legal.querySelector('a[href="faq.html"]');
    const support = document.createElement("a");
    support.href = "support.html";
    support.textContent = "Support";
    if (faq) faq.insertAdjacentElement("afterend", support);
    else legal.insertAdjacentElement("afterbegin", support);
  }
  if (!footer.querySelector(".site-footer__copy")) {
    const copy = document.createElement("p");
    copy.className = "site-footer__copy";
    copy.textContent = copyrightNotice();
    footer.appendChild(copy);
  }
}

/** App shell footer or landing copyright line - safe to call on every page. */
export function ensureCopyrightFooter() {
  const main = document.querySelector(".main");
  if (main) {
    ensureAppShellFooter(main);
  } else {
    const landingFooter = document.querySelector(".landing-footer");
    if (landingFooter) {
      if (!landingFooter.querySelector(".landing-footer__copy")) {
        const copy = document.createElement("p");
        copy.className = "landing-footer__copy";
        copy.textContent = copyrightNotice();
        landingFooter.appendChild(copy);
      }
    } else if (!document.querySelector(".site-footer")) {
      const footer = document.createElement("footer");
      footer.className = "landing-footer landing-footer--minimal";
      footer.innerHTML = `${legalFooterLinksHtml()}<p class="landing-footer__copy">${copyrightNotice()}</p>`;
      document.body.appendChild(footer);
    }
  }

  wireLegalLinks();
}
